import React, { Component, useState, useEffect } from "react"
import PropTypes from "prop-types"
import queryString from "query-string"
import SbEditable from "storyblok-react"
import Components from "../index"
import SbImageService from "../../helpers/SbImageService"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import linkHandler from "../../helpers/storyblokLinkHandler"
import IconV2 from "../icon-v2"
import instagramIcon from "../../assets/images/instagram.png"
import messengerIcon from "../../assets/images/messenger.png"
import ShareOptions from "./partials/share-options"
import {
  StyledHero,
  StyledHeroCard,
  StyledHeroCardLogo,
  StyledHeroCardHeading,
  StyledHeroCardBody,
  StyledHeroImage,
} from "./partials"

export const HeroV2Share = ({ blok }) => {
  const [contact, setContact] = useState({})
  const [contactId2, setContactId] = useState("")
  useEffect(() => {
    if (typeof window !== "undefined") {
      const queryParams = queryString.parse(window.location.search)
      const contactId = queryParams.S
      let contact = {}
      let contactId2 = ""
      if (contactId) {
        fetch(
          `${process.env.GATSBY_SALESFORCE_API}/hulthousing/services/apexrest/GetContactInfo`,
          {
            method: "post",
            body: JSON.stringify({ contactID: contactId }),
          }
        )
          .then((resp) => {
            return resp.json()
          })
          .then((data) => {
            setContact(JSON.parse(data))
            setContactId(contactId)
          })
      } else {
        setContact({})
      }
    }
  }, [])
  return (
    <SbEditable content={blok}>
      <StyledHero>
        <StyledHeroCard>
          {blok.logo.filename && (
            <StyledHeroCardLogo
              desktop
              title="Hult"
              href={linkHandler(blok.logoUrl)}
            >
              <img alt="Hult" src={blok.logo.filename} />
            </StyledHeroCardLogo>
          )}
          {blok.logoMobile.filename && (
            <StyledHeroCardLogo
              tablet
              title="Hult"
              href={linkHandler(blok.logoUrl)}
            >
              <img alt="Hult" src={blok.logoMobile.filename} />
            </StyledHeroCardLogo>
          )}
          {blok.title && (
            <StyledHeroCardHeading>
              {contact.FirstName ? contact.FirstName + ", " : ""}
              {blok.title}
            </StyledHeroCardHeading>
          )}
          {blok.body && (
            <StyledHeroCardBody>
              {
                unified()
                  .use(remarkParse)
                  .use(remarkRehype)
                  .use(rehypeReact, {
                    createElement: React.createElement,
                    components: remarkReactComponents,
                    Fragment: React.Fragment,
                  })
                  .processSync(blok.body).result
              }
            </StyledHeroCardBody>
          )}
          <ShareOptions
            content={blok}
            shared_title={blok.shared_title}
            shared_url={blok.shared_url + "?S=" + contactId2}
            instagram={blok.instagram}
            whatsapp={blok.whatsapp}
            email={blok.email}
            linkedin={blok.linkedin}
            sms={blok.sms}
            messenger={blok.messenger}
            copy_link={blok.copy_link}
            // native_share={blok.native_share}
          />
        </StyledHeroCard>
        <StyledHeroImage image={SbImageService(blok.image.filename)} />
      </StyledHero>
    </SbEditable>
  )
}

export default HeroV2Share
